<template>
  <!-- Veřejná stránka ověření — Blade app-nav je nad #app, vlastní navbar odstraněn -->
  <div class="verif-page">

    <main class="verif-page__main">
      <div class="verif-card">

        <!-- Tlačítko zpět — vrátí na předchozí stránku nebo na dashboard -->
        <div class="verif-card__back">
          <button class="auth-back-btn" @click="$router.back()">
            <img :src="iconChevronLeft" alt="">
            {{ $t('general.back') }}
          </button>
        </div>

        <!-- Záhlaví karty: ikona + nadpis + popis -->
        <div class="verif-card__header">
          <img :src="iconMagnifying" alt="" class="verif-card__icon">
          <div>
            <h1 class="verif-card__title">{{ $t('cert.fileCertVerification') }}</h1>
            <p class="verif-card__subtitle">{{ $t('cert.verifyPageSubtitle') }}</p>
          </div>
        </div>

        <!-- Formulář pro ověření -->
        <div class="verif-card__body">
          <CertVerificationComponent />
        </div>

        <!-- Výsledek ověření — zobrazí se po odeslání formuláře -->
        <div v-if="verificationMessage" class="verif-card__result">
          <div v-if="verificationResult !== 'false' && verificationResult !== false" class="verif-result verif-result--ok">
            <div class="shared-cert-badge shared-cert-badge--ok verif-result__badge">
              <i class="bi bi-check-lg shared-cert-badge__icon"></i>
              <span>{{ $t('cert.verifyResultOk') }}</span>
            </div>
            <p class="verif-result__message">{{ verificationMessage }}</p>
          </div>
          <div v-else class="verif-result verif-result--fail">
            <div class="shared-cert-badge shared-cert-badge--warn verif-result__badge">
              <i class="bi bi-exclamation-triangle-fill shared-cert-badge__icon"></i>
              <span>{{ $t('cert.verifyResultFail') }}</span>
            </div>
            <p class="verif-result__message">{{ verificationMessage }}</p>
          </div>
        </div>

      </div>
    </main>

  </div>
</template>

<script>
import CertVerificationComponent from '../components/certs/CertVerificationComponent.vue';
import iconMagnifying from '/public/img/new-design/icons/magnifying.svg';
import iconChevronLeft from '/public/img/new-design/icons/chevron-left.svg';

export default {
  components: { CertVerificationComponent },

  data() {
    return {
      verificationResult: false,
      verificationMessage: null,
      iconMagnifying,
      iconChevronLeft,
    };
  },

  mounted() {
    // Nasloucháme výsledku ověření z CertVerificationComponent
    this.emitter.on('certChecked', (certVerificationResult) => {
      this.verificationResult = certVerificationResult.verificationStatus.verified;
      this.verificationMessage = certVerificationResult.verificationStatus.message;
    });
  },
};
</script>